import React from 'react';

export function useToggle(initialValue = false) {
   const [value, setValue] = React.useState(initialValue);
   const toggle = () => setValue((prev) => !prev);
   const open = () => setValue(true);
   const close = () => setValue(false);
   return [value, toggle, open, close] as [boolean, () => void, typeof open, typeof close];
}
